module.exports = __webpack_public_path__ + "static/media/15_720.32f13798.jpeg";